/**
 * pdfI18n.ts — i18n access for the PDF builders (pdfmake).
 *
 * The rider / daysheet / tourbook / checklist / SETLIST docDef builders are imperative
 * code OUTSIDE React, so the `useTranslation()` hook is unavailable. We import
 * the shared i18n singleton (src/i18n) instead and call `t()` directly: it
 * resolves against the ACTIVE language at generation time (EN default, FR if
 * the user chose FR), falling back to EN for missing keys.
 *
 * All PDF labels live under the `pdf.*` namespace in en.json / fr.json.
 * Values in en.json are byte-identical to the strings the builders emitted
 * before i18n, so the EN output is unchanged.
 */
import i18n from '../i18n';

/** Bound translate function reading the current language. */
export const t = i18n.t.bind(i18n);

/**
 * BCP-47 locale matching the ACTIVE i18n language, for date/number formatting
 * in the PDF/doc builders and exported documents (emails, itinerary…).
 * `en-GB` stays the default so the English output is byte-identical to before.
 */
const LOCALE_BY_LANG: Record<string, string> = {
  en: 'en-GB',
  fr: 'fr-FR',
  es: 'es-ES',
};

export function pdfLocale(): string {
  const base = String((i18n && i18n.language) || 'en').split('-')[0].toLowerCase();
  return LOCALE_BY_LANG[base] || 'en-GB';
}

export default i18n;
